import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {TaskAlert, TaskAlertRecipientWithStatus, TaskPeopleWithNotificationStatus} from '../../models/task-manager.model';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {select, Store} from '@ngrx/store';
import {CommandService} from '@core/services/command.service';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {take, takeUntil} from 'rxjs/operators';
import {QueryProvider} from '@shared/queries/query-provider';
import {AddTaskAlertCommand, SendTaskAlertNowCommand, UpdateTaskAlertCommand} from '../../commands/task-manager.command';
import {DialogService} from '@shared/services/dialog-service';
import {TaskManagerState} from '../../store/task-manager.reducer';
import {getDueStateList, getStatusList} from '../../store/task-manager.selector';
import {FormBuilder, Validators} from '@angular/forms';
import {TimeZoneService} from '@core/services/time-zone.service';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {Configuration} from '@shared/models/configuration';
import {
  TaskNotificationStatusCellViewerComponent
} from '../task-notification-status-cell-viewer/task-notification-status-cell-viewer.component';
import {ParticleService} from '@core/services/particle.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {GraphQLService} from '@core/services/graphql.service';
import {TaskManagerQuery} from '../../helpers/task-manager.query';
import {TaskManagerConfig} from '../../helpers/task-manager.config';
import {FieldDefinition} from '@shared/models/field-definition';
import {TaskManagerApiService} from '../../services/task-manager-api.service';
import {OptionItem} from '@shared/models/option-item';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {IVirtualGridCollectionState} from '@shared/store/reducers/virtual-grid.reducer';
import {getVirtualGridItems, getVirtualGridItemsMetaData} from '@shared/store/selectors/virtual-grid.selector';
import {SelectableSettings} from '@progress/kendo-angular-grid';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {ConfirmationDialogData} from '@shared/models/confirmation-dialog-data.model';
import {ConfirmationDialogComponent} from '@shared/components/confirmation-dialog/confirmation-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {PlatformCommand} from '@shared/commands/command-base';
import {Api} from '@shared/constants/common-field.constants';
import {DateUtility} from '@shared/utility/date-utility';
import {StringUtility} from '@shared/utility/string-utility';
import {ChatEditorOutput} from '@shared/models/chat-editor.model';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {Contact} from "@features/contacts/store/contact.model";
import {PlatformQuery, PlatformQueryResponse} from '@shared/models/platform-query/platform-query';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {QueryModel} from '@shared/models/query-model';

@Component({
    standalone: false,
    selector: 'particle-task-alert',
  templateUrl: './task-alert.component.html',
  styleUrls: ['./task-alert.component.scss']
})
export class TaskAlertComponent implements OnInit, OnDestroy, IDialogView {
  hasNotificationPermission: boolean;
  dueStateList$: Observable<any[]>;
  onContainerChangeEvent$ = new Subject<void>();
  alertDate: Date;
  taskAlerts: TaskAlert[];
  taskAlerts$: any;
  dynamicData: any;
  data: any;
  card: any;
  unsubscribe$: Subject<void>;
  numbers: Number[];
  daysDifferenceType: any[];
  beforeAfterType: any[];
  key = 'TaskAlertsKey';
  checkListKey = 'ChecklistKey';
  statusList$: any;
  showCustomMessageBox = false;
  alertForm: any;
  alertFormErrors: any;
  isSendNow: boolean;
  alwaysTrue: true;
  taskAlertIdentifier = {};
  selectedAlert: string;
  sourceType = 'Notification-Status';
  invalidateSubject: InvalidateSubject;
  isDisabled = false;
  sendNowClicked: boolean;
  isTaskAlertDisabled = {};
  expandedAlert = {};
  notificationAdded = false;
  initialNotifications = true;
  attachmentCount: number;
  defaultTabSelected = 0;
  checklistCount: number = 0;
  checklists$: any;
  notificationStatusLabel: string;
  isValidStartDate: boolean = false;
  isValidDueDate: boolean = false;
  totalNumberOfNotificationStatusCount: number;
  totalNumberOfTaskAlert: number;
  mention$: BehaviorSubject<Contact> = new BehaviorSubject<Contact>(null);
  @Output() indirectlyMenuClickedEvent = new EventEmitter<string>();
  actionEvent$: BehaviorSubject<any> = new BehaviorSubject(null);
  // selectedMemberForAlerts: Map<string, any[]> = new Map<string, any[]>();
  serviceName = 'NotificationStatusDynamicItemService';
  parameters: any;
  selectableSettings: SelectableSettings = {
    enabled: true,
    checkboxOnly: true,
    mode: 'multiple'
  };
  contactQueryKey = 'AllContactList';

  //TaskAlert.isDirty === true means we need to show confirmation to the user on Cancel/Done click if the user want to save the Notification/TaskAlert.
  //TaskAlert.isConfirmDirty === true means we need to save without any confirmation on Cancel/Done click.
  //For example when title is changed, we don't need to show confirmation.


  // send notification now
  // ticketMembers: Map<string, any[]> = new Map<string, any[]>();
  acceptedContacts = new Set();
  allRecipients$: BehaviorSubject<TaskAlertRecipientWithStatus[]> = new BehaviorSubject([]);
  fieldDefinitions$: BehaviorSubject<FieldDefinition[]> = new BehaviorSubject(
    [
      <FieldDefinition>{
        header: 'Name',
        cellViewer: 'NameCellViewerComponent',
        dataType: 'string',
        key: 'Name'
      },
      <FieldDefinition>{
        header: 'Email',
        cellViewer: 'StringCellViewer',
        dataType: 'string',
        key: 'Email',
        width: 70
      },
      <FieldDefinition>{
        header: 'Last Notification Status',
        cellViewer: 'TaskNotificationStatusCellViewer',
        dataType: 'string',
        key: 'StatusTooltip',
        width: 70,
        options: [
          <OptionItem>{
            id: 'Not Sent',
            text: 'Not Sent',
            tags: ['#f3f3f3', '#9b9b9b', 'far fa-ellipsis-h'],
            isCustom: false
          },
          <OptionItem>{
            id: 'Sent',
            text: 'Sent',
            tags: ['#fff3e6', '#fcb86b', 'far fa-paper-plane'],
            isCustom: false
          },
          <OptionItem>{
            id: 'Received',
            text: 'Received',
            tags: ['#ebf1f9', '#337aee', 'far fa-check'],
            isCustom: false
          },
          <OptionItem>{
            id: 'Confirmed',
            text: 'Confirmed',
            tags: ['#eaf5e8', '#7ec57c', 'far fa-check-double'],
            isCustom: false
          },
          <OptionItem>{
            id: 'Bounced',
            text: 'Bounced',
            tags: ['#f58a6c', '#ed5435', 'far fa-exclamation-circle'],
            isCustom: false
          }
        ]
      }
    ]
  );
  allAlertPeoples: any = {};
  checked: boolean = true;
  private ngUnsubscribe$ = new Subject<void>();
  private response$: any;
  private id = 'task-alert-view';
  isEatTicket = false;
  currentlySelectedTabIndex = 0;
  api: string;

  constructor(private commandService: CommandService,
              private queryStore: Store<IQueryState>,
              private dialogService: DialogService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private taskManagerStore: Store<TaskManagerState>,
              private formBuilder: FormBuilder,
              private particleService: ParticleService,
              private graphQLService: GraphQLService,
              private taskManagerApiService: TaskManagerApiService,
              private snackBarService: SnackBarService,
              private timeZoneService: TimeZoneService,
              private virtualGridStore: Store<IVirtualGridCollectionState>,
              private dialog: MatDialog,
              private platformQueryService: PlatformQueryService) {
    this.particleService.registerCellComponent('TaskNotificationStatusCellViewer', TaskNotificationStatusCellViewerComponent);
    this.invalidateSubject = new InvalidateSubject();
    this.taskAlerts = [];
    this.unsubscribe$ = new Subject<void>();
    this.numbers = [1, 2, 3, 4, 5, 6, 7];
    this.daysDifferenceType = [
      {
        DisplayText: 'Day(s)',
        Key: 'Days'
      }, {
        DisplayText: 'Week(s)',
        Key: 'Weeks'
      }, {
        DisplayText: 'Month(s)',
        Key: 'Months'
      }
    ];
    this.beforeAfterType = [
      {
        Key: "Before",
        DisplayText: "Before",
      },
      {
        Key: "After",
        DisplayText: "After",
      },
    ]
    this.alertFormErrors = {
      alertDate: {}
    };
    this.acceptedContacts = new Set();
  }

  ngOnInit() {
    this.api = 'TaskManagerApi';
    if (this.dynamicData.parameters?.taskApi) {
      this.api = this.dynamicData.parameters?.taskApi;
    }
    const config = this.getQueryModel(this.sourceType);
    this.alertForm = this.formBuilder.group({
      alertDate: [new Date(new Date().getFullYear(), 11, 31), Validators.required]
    });
    this.alertForm.valueChanges.subscribe(() => {
      this.onFormValuesChanged();
    });
    if (this.dynamicData && this.dynamicData.selectedMenuDetail && this.dynamicData.selectedMenuDetail.input
      && this.dynamicData.selectedMenuDetail.input.selectedNotificationTab) {
      this.defaultTabSelected = this.dynamicData.selectedMenuDetail.input.selectedNotificationTab;
      this.currentlySelectedTabIndex = this.defaultTabSelected;
    }
    if (this.dynamicData && this.dynamicData.card) {
      this.card = this.dynamicData.card;
      this.parameters = {
        TicketId: this.card.id,
        Scope: this.card.scopeInt,
        HasVirtualGridConfig: true,
        Api: this.api,
        SourceType: this.sourceType
      };
      this.validateDates(this.card);
      this.checkForSource(this.card);
      config.Parameters.TICKET_ID = this.card.id;
      config.Parameters.SCOPE = this.card.scopeInt;
      config.api = this.api;
      const selectedTaskQuery = TaskManagerQuery.getSelectedTask(this.card.id, this.card.scope);
      this.graphQLService.executePostRequest(this.api, selectedTaskQuery).subscribe((selectedTicket: any) => {
        if (selectedTicket) {
          this.attachmentCount = selectedTicket.data.ticketWithBoard.attachmentCount;
        }
      });
      this.statusList$ = this.taskManagerStore.pipe(takeUntil(this.unsubscribe$), select(getStatusList));
      this.dueStateList$ = this.taskManagerStore
        .pipe(takeUntil(this.unsubscribe$), select(getDueStateList));
      this.invalidate();
    }
    this.response$ = this.queryStore.pipe(select(getQueryResponse, this.contactQueryKey)).pipe(takeUntil(this.unsubscribe$));
    this.response$.subscribe(response => {
      if (response) {
        const allContacts = response.contacts;
        if (allContacts && allContacts.length > 0) {
          allContacts.forEach(contact => {
            if (contact && contact.user && contact.user.email && contact.user.status === 2) {
              this.acceptedContacts.add(contact.user.email.toLowerCase());
            }
          });
        }
      }
    });
    QueryProvider.invokeQuery(this.queryStore, this.contactQueryKey, {});
    this.virtualGridStore.pipe(select(getVirtualGridItemsMetaData, this.sourceType), takeUntil(this.ngUnsubscribe$))
      .subscribe((res: any) => {
          if (res && res.HasNotificationPermission) {
            console.log('[HasNotificationPermission]', res.HasNotificationPermission);
            this.hasNotificationPermission = res.HasNotificationPermission === 'True';
          }
        }
      );


    this.data.optionalButtonsCaption = 'Save Notification(s)';
    this.data.isDisabledOptionalButtonsCaption = true;
    const gridItems = this.queryStore.pipe(select(getVirtualGridItems, this.sourceType), takeUntil(this.unsubscribe$)).subscribe(res => {
      if (res && res.length != null) {
        this.notificationStatusLabel = `Notification History (${res.length})`;
        this.totalNumberOfNotificationStatusCount = res.length;
        this.checkIsDirtyByNotificationStatusAndTaskAlerts();
      } else {
        this.notificationStatusLabel = 'Notification History';
      }
    });
  }

  private platformQuery(name : string, api: string, fieldValues: any): PlatformQuery {
    const query = new PlatformQuery();
    query.api = api;
    query.name = name;
    query.fieldValues = fieldValues;
    return query;
  }

  addPeopleButtonClicked() {
    // this.indirectlyMenuClickedEvent.emit('TaskAssignee');
    this.actionEvent$.next({id: 'TaskAssignee', type: 'MainViewBodyChangeEvent', card: this.dynamicData.card});
  }

  onSelectedKeyChange(taskAlert: any, keys: string[]) {
    const temp: string[] = [...keys];
    taskAlert.selectedRecipients = temp.filter(sel => this.isAcceptedContact(sel));
    taskAlert.selectedRecipientsCount = taskAlert.selectedRecipients.length;
  }

  changeValue(value) {
    this.checked = !value;
  }

  hasDirtyTaskAlerts(): boolean {
    return this.taskAlerts.some(ta => ta.isDirty === true);
  }

  // TODO: do not find any
  addTaskAlert() {
    if (this.hasDirtyTaskAlerts()) {
      const confirmationDialogData = new ConfirmationDialogData('Unsaved Notification(s)',
        'You have unsaved notification(s). Do you want to save these notification(s) before closing the task?', ['No', 'Yes']);
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        data: confirmationDialogData
      });

      dialogRef.afterClosed().pipe(
        take(1)).subscribe(confirmationResult => {
        if (confirmationResult === 'Yes') {
          this.saveTaskAlerts().pipe().subscribe(res => {
            if (res) {
              this.executeAddTaskAlert();
            }
          });
        } else {
          this.executeAddTaskAlert();
        }
      });
    } else {
      this.executeAddTaskAlert();
    }
  }

  executeAddTaskAlert() {
    const addTaskAlertCommand = new PlatformCommand('AddTaskAlertPlatformCommand', this.api);
    addTaskAlertCommand.fieldValues = {
      TicketId: this.card.id
    };
    addTaskAlertCommand.scope = this.card.scopeInt;
    this.notificationAdded = true;
    this.commandService.executePlatformCommand(addTaskAlertCommand).pipe().subscribe(state => {
      this.invalidate();
    });
  }

  startTaskAlertEdit(taskAlert: TaskAlert) {
    this.isDisabled = true;
    this.isTaskAlertDisabled[taskAlert.id] = true;
    this.resetEditing(taskAlert.id);
    taskAlert.isEditing = true;
  }

  resetEditing(taskAlertId: string) {
    this.isDisabled = false;
    this.isTaskAlertDisabled[taskAlertId] = false;
    this.taskAlerts.forEach(ch => {
      ch.isEditing = false;
      ch.isEditing = false;
    });
  }

  taskAlertTitleChanged(taskAlert: TaskAlert, $event: any) {
    if (this.isDuplicateTaskAlertTitleExists(taskAlert.id, $event.text)) {
      this.snackBarService.showError('Notification title already exists');
      this.resetEditing(taskAlert.id);
      return;
    }

    taskAlert.title = $event.text;
    this.resetEditing(taskAlert.id);
    const saveTaskAlertTitleCommand = new PlatformCommand('SaveNotificationTitleCommand', this.api);
    saveTaskAlertTitleCommand.fieldValues['TaskAlertId'] = taskAlert.id;
    saveTaskAlertTitleCommand.fieldValues['UpdatedTitle'] = $event.text;
    saveTaskAlertTitleCommand.scope = this.card.scopeInt;

    this.commandService.executePlatformCommand(saveTaskAlertTitleCommand).subscribe(response => {
      this.snackBarService.showInformation('Notification Title is saved successfully');
    });
  }

  isDuplicateTaskAlertTitleExists(id: string, title: string): boolean {
    let duplicateExists = false;

    this.taskAlerts.forEach(taskAlert => {
      if (taskAlert.title === title && taskAlert.id !== id) {
        duplicateExists = true;
      }
    });
    return duplicateExists;
  }

  updateTaskAlert(taskAlert: TaskAlert, event = null) {
    // console.log(event);
    if (event) {
      // taskAlert.alertDate=new Date(this.timeZoneService.dateTostringWithoutUTC(event.value));
      const dateTime = new Date(this.timeZoneService.dateTostringWithoutUTC(event.value));
      taskAlert.certainDateTrigger.alertDate = dateTime;
    } else if (taskAlert.certainDateTrigger.alertDate) {
      const dateTime = new Date(this.timeZoneService.dateTostringWithoutUTC(taskAlert.certainDateTrigger.alertDate));
      taskAlert.certainDateTrigger.alertDate = dateTime;
    }
    this.makeDirty(taskAlert);
    this.resetEditing(taskAlert.id);
    console.log(this.taskAlerts.find(alert => alert.id === taskAlert.id));
    /*const command = new UpdateTaskAlertCommand(taskAlert);
    command.scope = this.card.scopeInt;
    this.commandService.executeCommand(command).pipe().subscribe(state => {
      this.invalidate();
      this.invalidateSubject.invalidate();
    });*/
  }

  showSendNowNotification() {
    this.snackBarService.showInformation('Notification Sent Successfully');
  }

  onGridCellValueChange(event) {
    if (event.action) {
      switch (event.action.id) {
        case 'Delete':
          if (event.item.cells.Status.value !== 'NotSent') {
            this.snackBarService.showError('You can delete \'Not Sent\' notifications only');
          } else {
            this.dialogService.showYesNoDialog('Confirm Delete', `Are you sure you want to delete this Notification?`).subscribe(userResponse => {
              if (userResponse.action === 'OK') {
                const deleteNotificationCommand = new PlatformCommand('DeleteNotificationStatusCommand', this.api);
                deleteNotificationCommand.scope = this.card.scopeInt;
                deleteNotificationCommand.setValue('NotificationStatusId', event.item.id);
                this.commandService.executePlatformCommand(deleteNotificationCommand).subscribe(response => {
                    this.snackBarService.showInformation('Notification Deleted Successfully');
                    this.invalidateSubject.invalidate();
                    this.invalidateTaskViews();
                  },
                  err => {
                    this.invalidateSubject.invalidate();
                  });
              }
            });
          }
          break;
      }
      return;
    }
  }

  onFieldSectionChanged(event) {

  }

  onOpenPanel(taskAlert: TaskAlert) {
    this.expandedAlert[this.selectedAlert] = false;
    this.selectedAlert = taskAlert.id;
    this.expandedAlert[taskAlert.id] = true;
    taskAlert.selectedNotificationTab = 0;

  }

  onClosePanel(taskAlert: TaskAlert) {
    taskAlert.selectedNotificationTab = 0;
    this.expandedAlert[taskAlert.id] = false;
  }

  onCloseSendNotificationNowPanel(taskAlert: TaskAlert){

  }

  onOpenSendNotificationNowPanel(taskAlert: TaskAlert){
    this.fetchTaskMemberWithNotificationStatus(taskAlert);
  }

  onCloseScheduleNotificationNowPanel(taskAlert: TaskAlert){

  }

  onOpenScheduleNotificationNowPanel(taskAlert: TaskAlert){

  }

  sendTaskAlert(taskAlert: TaskAlert) {
    if (this.hasDirtyTaskAlerts()) {
      this.saveTaskAlerts().pipe().subscribe(res => {
        if (res) {
          this.executeSendTaskAlert(taskAlert);
        }
      });
    } else {
      this.executeSendTaskAlert(taskAlert);
    }
  }

  executeSendTaskAlert(taskAlert) {
    // this.resetEditing();
    const command = new PlatformCommand('SendTaskAlertNowCommand', this.api);
    command.scope = this.card.scopeInt;
    command.fieldValues = {
      TaskAlert: taskAlert,
      SelectedRecipients: taskAlert.selectedRecipients
    };
    this.fuseSplashScreenService.show();
    this.commandService.executePlatformCommand(command).pipe().subscribe(state => {
      this.fuseSplashScreenService.hide();
      this.snackBarService.showInformation('Notification Sent Successfully');
      this.invalidate();
      this.invalidateSubject.invalidate();
    }, err => {
      this.fuseSplashScreenService.hide();
      let errMsg = 'Notification sending failed!!!';
      if (err.Payload) {
        errMsg = StringUtility.sanitize(err.Payload);
      }
      this.snackBarService.showError(errMsg);
    });
  }

  removeTaskAlert(taskAlert: TaskAlert) {
    this.dialogService.showYesNoDialog('Delete Notification', 'Are you sure you want to delete this Notification?').subscribe(state => {
      if (state && state.action === 'OK') {
        this.resetEditing(taskAlert.id);

        const deleteTaskAlertCommand = new PlatformCommand('DeleteTaskAlertCommand', this.api);
        deleteTaskAlertCommand.scope = this.card.scopeInt;
        deleteTaskAlertCommand.fieldValues['TaskAlertId'] = taskAlert.id;

        this.commandService.executePlatformCommand(deleteTaskAlertCommand).subscribe(response => {
          this.invalidateTaskViews();
          this.snackBarService.showInformation('Notification is Deleted Successfully');
          delete this.taskAlertIdentifier[taskAlert.id];
          taskAlert.isDeleted = true;
        });
      }
    });
  }

  onFormValuesChanged() {
    for (const field in this.alertFormErrors) {
      if (!this.alertFormErrors.hasOwnProperty(field)) {
        continue;
      }

      // Clear previous errors
      this.alertFormErrors[field] = {};

      // Get the control
      const control = this.alertForm.get(field);

      if (control && control.dirty && !control.valid) {
        this.alertFormErrors[field] = control.errors;
      }

    }


  }

  onNotificationChange(event, taskAlert: TaskAlert) {
    if (event.value === '1') {
      this.taskAlertIdentifier[taskAlert.id] = true;
    } else {
      this.taskAlertIdentifier[taskAlert.id] = false;
    }
  }

  getDefaultValue(taskAlert: TaskAlert) {
    if (taskAlert.dueDateTrigger.isChecked) {
      return 2;
    } else if (taskAlert.certainDateTrigger.isChecked) {
      return 2;
    } else if (taskAlert.statusTrigger.isChecked) {
      return 2;
    } else {
      return 1;
    }

  }

  setExpandedAlert() {
    if (this.taskAlerts.length > 0) {
      if (this.notificationAdded) {
        this.expandedAlert[this.selectedAlert] = false;
        this.expandedAlert[this.taskAlerts[this.taskAlerts.length - 1].id] = true;
        this.notificationAdded = false;
        this.selectedAlert = this.taskAlerts[this.taskAlerts.length - 1].id;
      }
      if (this.initialNotifications) {
        this.expandedAlert[this.taskAlerts[0].id] = true;
        this.initialNotifications = false;
        this.selectedAlert = this.taskAlerts[0].id;
      }
      if (this.selectedAlert && this.expandedAlert && this.expandedAlert.hasOwnProperty(this.selectedAlert)) {
        this.expandedAlert[this.selectedAlert] = true;
      }
    }
  }

  onTabIndexChange(index: number, taskAlert: TaskAlert) {
    taskAlert.selectedNotificationTab = index;
    if (index === 1) {
      this.fetchTaskMemberWithNotificationStatus(taskAlert);
    }
  }

  ngOnDestroy(): void {
    if (this.acceptedContacts) {
      this.acceptedContacts.clear();
    }
    this.data.optionalButtonsCaption = '';
    this.data.isDisabledOptionalButtonsCaption = true;
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  updateTaskAlertStatus(status: any, taskAlert: TaskAlert) {
    taskAlert.statusTrigger.statusToTrigger = [status];
    taskAlert.statusTrigger.status = status;
    console.log(taskAlert.statusTrigger.statusToTrigger);
    this.updateTaskAlert(taskAlert);
  }

  updateTaskAlertForDueDate(taskAlert: TaskAlert, dueState: any) {
    if (taskAlert.certainDateTrigger.alertDate) {
      const dateTime = new Date(this.timeZoneService.dateTostringWithoutUTC(taskAlert.certainDateTrigger.alertDate));
      taskAlert.certainDateTrigger.alertDate = dateTime;
    }
    taskAlert.dueStateTrigger.stateTitle = dueState.title;
    taskAlert.dueStateTrigger.stateToTrigger = [dueState.title];
    this.makeDirty(taskAlert);
    this.resetEditing(taskAlert.id);
    /*const command = new UpdateTaskAlertCommand(taskAlert);
    command.scope = this.card.scopeInt;
    this.commandService.executeCommand(command).pipe().subscribe(state => {
      this.invalidate();
      this.invalidateSubject.invalidate();
    });*/
  }

  onOkClicked(): any {
    console.log('....onOkClicked.....');
    return this.saveWithConfirmation();
  }

  showSeccessFailMsg() {
    this.snackBarService.showInformation('Notification(s) Saved Successfully');
  }

  onClosedClicked(): any {
    return this.onCancelClicked();
  }

  onCancelClicked(): any {
    console.log('....onCancelClicked.....');
    return this.saveWithConfirmation();
  }

  saveWithConfirmation(): any {
    const result = new Subject<any>();
    let isDirty = false, isConfirmedDirty: boolean = false;

    this.taskAlerts.forEach(taskAlert => {
      if (taskAlert.isDeleted) {
        return;
      }

      if (taskAlert.isDirty === true) {
        isDirty = true;
      } else if (taskAlert.isConfirmedDirty) {
        isConfirmedDirty = true;
      }
    });

    if (isDirty === false && isConfirmedDirty === false) {
      return true;
    }

    if (isDirty) {
      const confirmationDialogData = new ConfirmationDialogData('Unsaved Notification(s)',
        'You have unsaved notification(s). Do you want to save these notification(s) before closing the task?', ['No', 'Yes']);
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        data: confirmationDialogData
      });
      dialogRef.afterClosed().pipe(
        take(1)).subscribe(confirmationResult => {

        if (confirmationResult === 'Yes') {
          this.saveTaskAlerts().pipe().subscribe(res => {
            result.next(res);
            result.complete();
          });
        } else {
          result.next(true);
          result.complete();
        }
      });
    } else if (isConfirmedDirty) {
      this.saveTaskAlerts().pipe().subscribe(res => {
        result.next(res);
        result.complete();
      });
    }
    return result;
  }

  closeDialog() {
    if (this.data.dialogRef) {
      this.data.dialogRef.close({
        action: 'OK',
        data: this.data
      });
    }
  }

  makeDirty(taskAlert) {
    taskAlert.isDirty = true;
    let makeDirty = false;
    taskAlert.recipients.forEach(rec => {
      if (rec.isChecked === true && rec.memberCount > 0) {
        makeDirty = true;
      }
    });

    makeDirty &&= taskAlert.startDateTrigger.isChecked || taskAlert.dueDateTrigger.isChecked ||
      taskAlert.statusTrigger.isChecked || taskAlert.certainDateTrigger.isChecked ||
      taskAlert.dueStateTrigger.isChecked;

    if (makeDirty) {
      this.data.isDisabledOptionalButtonsCaption = false;
    } else {
      this.data.isDisabledOptionalButtonsCaption = true;
    }
  }

  onOptionalButtonClicked(): boolean {
    return this.saveTaskAlerts();
  }


  // TaskAlert.isDirty === true means we need to show confirmation to the user on Cancel/Done click if the user want to save the Notification/TaskAlert.
  // TaskAlert.isConfirmDirty === true means we need to save without any confirmation on Cancel/Done click.
  // For example when title is changed, we don't need to show confirmation.

  saveTaskAlerts(): any {
    console.log('....saveTaskAlerts.....');
    const result = new Subject<boolean>();
    const taskAlertsIDsProcessed = {};
    let isDirty: boolean = false;

    this.taskAlerts.forEach(ta => {
      if (ta.isDeleted) {
        return;
      }

      if (ta.isDirty === true || ta.isConfirmedDirty === true) {
        taskAlertsIDsProcessed[ta.id] = true;
        isDirty = true;
      } else if (ta.isConfirmedDirty) {
        taskAlertsIDsProcessed[ta.id] = true;
      }
    });

    if (Object.keys(taskAlertsIDsProcessed).length) {
      let isErr = {value: false};
      this.taskAlerts.forEach(taskAlert => {
        this.saveTaskAlert(taskAlert, taskAlertsIDsProcessed, isErr, result);
      });
    } else {
      result.next(true);
      result.complete();
    }

    return result;
  }

  saveTaskAlert(taskAlert, taskAlertsIDsProcessed ={}, isErr = {value: false}, result = new Subject<boolean>()){
    if (taskAlert.isDeleted) {
      return;
    }

    if ((taskAlert.isDirty === true || taskAlert.isConfirmedDirty)) {
      const command = new PlatformCommand('UpdateTaskAlertCommand', this.api);
      command.fieldValues = {
        TaskAlert: taskAlert
      };
      command.scope = this.card.scopeInt;
      this.commandService.executePlatformCommand(command).pipe().subscribe(response => {
        this.invalidateTaskViews();
        delete taskAlertsIDsProcessed[taskAlert.id];
        if (Object.keys(taskAlertsIDsProcessed).length === 0 && isErr.value === false) {
          taskAlert.isDirty ? this.snackBarService.showInformation('Notification(s) Saved Successfully') : null;
          result.next(true);
          result.complete();
        }

        this.invalidateSubject.invalidate();
        taskAlert.isDirty = false;
        this.data.isDisabledOptionalButtonsCaption = true;
      }, err => {
        if (err && err.Payload) {
          console.error('ERR: ' + err.Payload);
          delete taskAlertsIDsProcessed[taskAlert.id];
          if (Object.keys(taskAlertsIDsProcessed).length === 0 && isErr.value === true) {
            result.next(false);
            result.complete();
          }
          if (isErr.value === false) {
            this.snackBarService.showError(err.Payload);
            isErr.value = true;
          }
          this.data.isDisabledOptionalButtonsCaption = true;
        }
      });
    }
  }

  validateDates(card: any) {
    const startDate = card?.taskStartDate ? card.taskStartDate : card.startDate;

    this.isValidStartDate = DateUtility.isValidDateStringOrObject(startDate);
    this.isValidDueDate = DateUtility.isValidDateStringOrObject(card?.dueDate);
  }

  private invalidate() {
    this.invalidateTaskViews();
    this.invalidateSubject.invalidate();
    const checklistQuery = this.platformQuery('ChecklistsQuery', this.api, {TicketId: this.card.id, Scope: this.card.scopeInt});
    //this.checklists$ = this.queryStore.pipe(select(getQueryResponse, this.checkListKey));
    this.checklists$ = this.executeQuery(checklistQuery);
    this.checklists$.pipe(takeUntil(this.unsubscribe$)).subscribe(res => {
      const state = res.fieldValues['Checklists'];
      if (state) {
        this.checklistCount = state.length;
      }
    });
    const taskAlertsQuery = this.platformQuery('TaskAlertsQuery', this.api, {TicketId: this.card.id, Scope: this.card.scopeInt});
    this.taskAlerts$ = this.executeQuery(taskAlertsQuery);
    this.taskAlerts$.pipe(takeUntil(this.unsubscribe$)).subscribe(res => {
      const state = res.fieldValues['TaskAlerts'];
      if (state) {
        const taskAlertState = [...state];
        taskAlertState.forEach(item => {
          if (item.certainDateTrigger.alertDate && (typeof item.certainDateTrigger.alertDate === 'string' || item.certainDateTrigger.alertDate instanceof String)) {
            item.certainDateTrigger.alertDate = this.timeZoneService.getDisplayDateFormISO(item.certainDateTrigger.alertDate);
          }
        });
        this.taskAlerts = taskAlertState;
        this.totalNumberOfTaskAlert = 0;
        this.taskAlerts.forEach(taskAlert => {
          if (taskAlert && taskAlert.statusTrigger
            && taskAlert.statusTrigger.statusToTrigger
            && taskAlert.statusTrigger.statusToTrigger.length > 0) {
            taskAlert.statusTrigger.commandSeparatedStatus = taskAlert.statusTrigger.statusToTrigger.join(', ');
          }
          if (taskAlert && taskAlert.dueStateTrigger
            && taskAlert.dueStateTrigger.stateToTrigger
            && taskAlert.dueStateTrigger.stateToTrigger.length > 0) {
            taskAlert.dueStateTrigger.commandSeparatedStatus = taskAlert.dueStateTrigger.stateToTrigger.join(', ');
          }
          taskAlert.selectedRecipients = [];
          taskAlert.selectedRecipientsCount = 0;
          taskAlert.selectedNotificationTab = 0;
          if (!(taskAlert.id in this.taskAlertIdentifier)) {
            this.taskAlertIdentifier[taskAlert.id] = true;
          }
          if (!(taskAlert.id in this.expandedAlert)) {
            this.expandedAlert[taskAlert.id] = false;
          }
          let totalPeople = 0;
          taskAlert.recipients.forEach(o => {
            totalPeople += o.memberCount;
          });

          const totalAlert = Number(taskAlert.startDateTrigger.isChecked) +
            Number(taskAlert.dueDateTrigger.isChecked) + Number(taskAlert.statusTrigger.isChecked) +
            Number(taskAlert.certainDateTrigger.isChecked) + Number(taskAlert.dueStateTrigger.isChecked);

          this.totalNumberOfTaskAlert += (totalPeople * totalAlert);

        });
        this.setExpandedAlert();
      }
      this.checkIsDirtyByNotificationStatusAndTaskAlerts();
    });
    // QueryProvider.invokeQuery(this.queryStore, this.key, {
    //   '[TASK_ID]': this.card.id,
    //   '[SCOPE]': this.card.scopeInt
    // });
    // QueryProvider.invokeQuery(this.queryStore, this.checkListKey, {
    //   '[TASK_ID]': this.card.id,
    //   '[SCOPE]': this.card.scopeInt
    // });
  }

  private convertForSendNotificationGrid(peoples: TaskPeopleWithNotificationStatus[]) {
    // this.ticketMembers = new Map<string, any[]>();
    // this.selectedMemberForAlerts = new Map<string, any[]>();
    const recipeints: TaskAlertRecipientWithStatus[] = [];
    const permissions: boolean[] = [];
    const selectedRecipients: any[] = [];
    if (peoples && peoples.length > 0) {
      peoples.forEach(people => {
        const acceptedContact = this.isAcceptedContact(people.user.email);
        if (people.notificationStatuses && people.notificationStatuses.length > 0) {
          people.notificationStatuses.forEach(status => {
            const recipient = new TaskAlertRecipientWithStatus();
            recipient.email = people.user.email;
            recipient.name = `${people.user.firstName} ${people.user.lastName}`;
            recipient.lastNotificationStatus = status.lastNotificationStatus;
            recipient.isDisable = !acceptedContact;
            permissions.push(people.hasPermission);
            recipeints.push(recipient);
            if (!status.isNotificationSent && this.isAcceptedContact(people.user.email)) {
              selectedRecipients.push(people.user.email);
            }
          });
        }
      });
    }
    this.selectableSettings.enabled = permissions.every(p => p === true);
    this.allRecipients$.next(recipeints);
    if (this.taskAlerts && this.taskAlerts.length > 0) {
      const alert = this.taskAlerts.find(a => a.id === this.selectedAlert);
      if (alert !== undefined) {
        alert.selectedRecipients = selectedRecipients;
        alert.selectedRecipientsCount = alert.selectedRecipients.length;
      }
    }
  }

  private isAcceptedContact(email: string) {
    if (!this.acceptedContacts) {
      return false;
    }
    // const status = this.contacts.findIndex(contact => contact.user && contact.user.email.toLowerCase() === email.toLowerCase() && contact.user.status === 2);
    const acceptedContact = this.acceptedContacts.has(email.toLowerCase());
    return acceptedContact;
  }

  private fetchTaskMemberWithNotificationStatus(taskAlert: TaskAlert) {
    this.allRecipients$.next([]);
    taskAlert.selectedRecipients = [];
    this.taskManagerApiService.getPeoplesWithNotificationStatusByAlertId(this.card.id, this.selectedAlert, this.card.scopeInt, this.api).pipe(take(2)).subscribe((res) => {
      const items = res.fieldValues['Items'];
      if (items) {
        this.convertForSendNotificationGrid(items);
      }
    });
  }

  private checkIsDirtyByNotificationStatusAndTaskAlerts() {
    if (this.totalNumberOfTaskAlert && this.totalNumberOfNotificationStatusCount) {
      if (this.totalNumberOfTaskAlert > this.totalNumberOfNotificationStatusCount) {
        this.taskAlerts.forEach(ta => this.makeDirty(ta));
      }
    }
  }

  private invalidateTaskViews() {
    if (this.data.input.taskInvalidator) {
      this.data.input.taskInvalidator.next({card: this.data.input.card, sourceViewId: this.id});
    }
  }

  private checkForSource(card: any) {
    if(!card) {
      return;
    }
    if(card && card.fieldValues && card.fieldValues.length > 0) {
      const hasFlowIdKey = (ele) => ele.Key === 'FlowId';
      this.isEatTicket = card.fieldValues.findIndex(hasFlowIdKey) > -1;
    }
  }

  sendMessage($event: ChatEditorOutput) {
    console.log('chat editor output:', $event);
  }

  onEditorValueChange($event: string, taskAlert: any) {
    taskAlert.customMessage = $event;
    this.updateTaskAlert(taskAlert);
  }

  onTabChange($event: number) {
    this.currentlySelectedTabIndex = $event;
  }

  private executeQuery(checklistQuery: PlatformQuery): Observable<PlatformQueryResponse>  {
    return this.platformQueryService.executeQuery(checklistQuery);
  }
  private getQueryModel(key: string) {
    const queryModelFromConfig = Configuration.getSmartGridConfig(key);
    const queryModelJsonString = JSON.stringify(queryModelFromConfig);
    return JSON.parse(queryModelJsonString);
  }
}
